import { render } from "./SimpleSwitchV2.vue?vue&type=template&id=30fd802a&scoped=true&ts=true"
import script from "./SimpleSwitchV2.vue?vue&type=script&lang=ts"
export * from "./SimpleSwitchV2.vue?vue&type=script&lang=ts"

import "./SimpleSwitchV2.vue?vue&type=style&index=0&id=30fd802a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fd802a"]])

export default __exports__